import { createApiMutation } from "../../generated-factory";
import { apiClientManager } from "@app/stores/api-manager";
import type { UseToggleVoucherRequest, UseToggleVoucherData, UseUpdateBillingRequest, UseUpdateBillingData, UseUpdateVoucherRequest, UseUpdateVoucherData } from "@api/@types/charge";

export const useToggleVoucher = createApiMutation<UseToggleVoucherData, UseToggleVoucherRequest>({
  mutationFn: (req) => apiClientManager.apis.charge.toggleVoucher(req as UseToggleVoucherRequest),
});

export const useUpdateBilling = createApiMutation<UseUpdateBillingData, UseUpdateBillingRequest>({
  mutationFn: (req) => apiClientManager.apis.charge.updateBilling(req as UseUpdateBillingRequest),
});

export const useUpdateVoucher = createApiMutation<UseUpdateVoucherData, UseUpdateVoucherRequest>({
  mutationFn: (req) => apiClientManager.apis.charge.updateVoucher(req as UseUpdateVoucherRequest),
});

export type { UseToggleVoucherRequest, UseToggleVoucherData, UseUpdateBillingRequest, UseUpdateBillingData, UseUpdateVoucherRequest, UseUpdateVoucherData } from "@api/@types/charge";
